// extracted by mini-css-extract-plugin
export default {"placeholderControl":"PlaceholderControl_placeholderControl__iY5OV"};